import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=a3f4ed80&"
import script from "./IconLink.vue?vue&type=script&lang=js&"
export * from "./IconLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3f4ed80')) {
      api.createRecord('a3f4ed80', component.options)
    } else {
      api.reload('a3f4ed80', component.options)
    }
    module.hot.accept("./IconLink.vue?vue&type=template&id=a3f4ed80&", function () {
      api.rerender('a3f4ed80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLink.vue"
export default component.exports